// customerHasApp searches through an array of app names. Returns true if the app exists in the apps array.
export const customerHasApp = (apps: string[], app: string): boolean => {
  if (!Array.isArray(apps)) {
    return false;
  }
  return !!apps.find((appName) => appName === app);
};
